export const SET_HRES6BU_INDEX_DISP = 'SET_HRES6BU_INDEX_DISP'
export const GET_HRES6BU_INDEX_DISP = 'GET_HRES6BU_INDEX_DISP'
export const SET_HRES6BU_DETAIL_DISP = 'SET_HRES6BU_DETAIL_DISP'
export const GET_HRES6BU_DETAIL_DISP = 'GET_HRES6BU_DETAIL_DISP'
export const GET_HRES6BU_MAX_ROWSPAN = 'GET_HRES6BU_MAX_ROWSPAN'
export const SET_HRES6BU_COLUMNS = 'SET_HRES6BU_COLUMNS'
export const GET_HRES6BU_COLUMNS = 'GET_HRES6BU_COLUMNS'
export const SET_HRES6BU_LABELS = 'SET_HRES6BU_LABELS'
export const GET_HRES6BU_LABELS = 'GET_HRES6BU_LABELS'
export const RECEIVED_HRES6BU_COLUMNS_LABELS = 'RECEIVED_HRES6BU_COLUMNS_LABELS'
export const SET_HRES6BU_INDEX = 'SET_HRES6BU_INDEX'
export const GET_HRES6BU_INDEX = 'GET_HRES6BU_INDEX'
export const RECEIVED_HRES6BU_INDEX = 'RECEIVED_HRES6BU_INDEX'
export const SET_HRES6BU_INDEX_SELECTED = 'SET_HRES6BU_INDEX_SELECTED'
export const GET_HRES6BU_INDEX_SELECTED = 'GET_HRES6BU_INDEX_SELECTED'
export const SET_HRES6BU_DETAIL = 'SET_HRES6BU_DETAIL'
export const GET_HRES6BU_DETAIL = 'GET_HRES6BU_DETAIL'
export const RECEIVED_HRES6BU_DETAIL = 'RECEIVED_HRES6BU_DETAIL'
export const TOGGLE_HRES6BU_PAGE = 'TOGGLE_HRES6BU_PAGE'
export const POST_HRES6BU_SEND_APPROVE = 'POST_HRES6BU_SEND_APPROVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres6bu/mutation-types.js